import { PersoneelsdienstModel } from "@personeel/models/PersoneelsdienstModel.ts";
import { VoorNaTijd } from "../VoorNaTijd/VoorNaTijd";
import { DienstStartEindeTijd } from "./DienstStartEindeTijd";
import { Dienstblok } from "./Dienstblok";
import { usePersoneelsinstellingenStore } from "@personeel/stores/PersoneelsinstellingenStore.ts";

interface IDienstTijden {
  dienst: PersoneelsdienstModel;
  scale: number;
  hidden?: boolean;
}

const BLOK_TIJD_MINUTEN = 30;

export function DienstTijden({ dienst, scale, hidden = false }: Readonly<IDienstTijden>) {
  const { personeelsinstellingen } = usePersoneelsinstellingenStore();
  return (
    !hidden && (
      <>
        <Dienstblok
          dienstTijd={dienst.starttijd.minus({ minute: BLOK_TIJD_MINUTEN })}
          isBeginTijd
          scale={scale}
        />
        <DienstStartEindeTijd dienstTijd={dienst.starttijd} isBeginTijd scale={scale} />
        <VoorNaTijd
          isVoorTijd
          startTijd={dienst.starttijd}
          eindTijd={dienst.starttijd.plus({ minute: personeelsinstellingen.voortijd })}
          scale={scale}
        />
        <DienstStartEindeTijd dienstTijd={dienst.eindtijd} scale={scale} />
        <VoorNaTijd
          startTijd={dienst.eindtijd.minus({ minute: personeelsinstellingen.natijd })}
          eindTijd={dienst.eindtijd}
          scale={scale}
        />
        <Dienstblok
          dienstTijd={dienst.eindtijd.plus({ minute: BLOK_TIJD_MINUTEN })}
          scale={scale}
        />
      </>
    )
  );
}
